var map = {
	"./symbol_0.png": 260,
	"./symbol_1.png": 79853,
	"./symbol_10.png": 65529,
	"./symbol_11.png": 59280,
	"./symbol_12.png": 73099,
	"./symbol_13.png": 98946,
	"./symbol_14.png": 44317,
	"./symbol_15.png": 23188,
	"./symbol_16.png": 44655,
	"./symbol_17.png": 63110,
	"./symbol_2.png": 48086,
	"./symbol_3.png": 1887,
	"./symbol_4.png": 73856,
	"./symbol_5.png": 98057,
	"./symbol_6.png": 33522,
	"./symbol_7.png": 55067,
	"./symbol_8.png": 67404,
	"./symbol_9.png": 62677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70303;